import http from "../../../../lib/http/httpClient";
import { Customer, Division, Report } from "../../../../types/settings";

export const getCustomers = async (): Promise<Customer[]> => {
    return http.get("/api/v1/cp/customers");
};

export const getDivisions = async (custId?: string): Promise<Division[]> => {
    const params = new URLSearchParams(custId ? { cust: custId } : {});
    return http.get(`/api/v1/cp/divisions/all${params.toString() ? `?${params}` : ""}`);
};

// Gets all reports if no cust_id is passed, if cust_id is passed, only returns reports which are unassigned to the customer
export const getReports = async (custId?: string): Promise<Report[]> => {
    const params = new URLSearchParams(custId ? { cust_id: custId } : {});
    return http.get(`/api/v1/cp/reports${params.toString() ? `?${params}` : ""}`);
};

// returns reports assigned to the customer
export const getCustomerReports = async (custId?: string): Promise<Report[]> => {
    const params = new URLSearchParams(custId ? { cust_id: custId } : {});
    return http.get(`/api/v1/cp/reports/customer${params.toString() ? `?${params}` : ""}`);
};

export const addCustomerReport = async (payload: {cust_id: string; report_id: string; }) => {
    return http.post("/api/v1/cp/reports/add", payload);
};

export const removeCustomerReport = async (payload: { cust_id: string; report_id: string; }) => {
    return http.delete("/api/v1/cp/reports/remove", { body: payload, });
};

export const createCustomer = async (payload: {
    cust_id: string;
    cust_name: string;
}) => {
    return http.post("/api/v1/cp/customers", payload);
};

export const createDivision = async (payload: {
    cust_id: string;
    divn_id: number;
    divn_name: string;
}) => {
    return http.post("/api/v1/cp/divisions", payload);
};
